import {store} from './store/index.js'

export default (to, from, next) => {
  console.log('auth-guard.js store.getters.user', store.getters.user)
  if (store.getters.user!==undefined && store.getters.user!==null) {
    console.log('auth-guard.js in next')
    next()
  } else {
    console.log('auth-guard.js in signin')
    var nxt = "signin"
    var vars = {};
    var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m,key,value) {
        vars[key] = value;
    });
    var redirect = vars['r'];
    if(redirect){
      nxt = nxt + "?r=" + redirect
    }
    console.log('auth-guard.js in signin nxt ' + nxt)
    next('/' + nxt)
  }
}